import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "rank_title public_flex_center" }
const _hoisted_3 = { class: "text public_flex_center" }

import { watchEffect } from 'vue';
import injectTool from './utils/injectTool';
import Home from './home.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'app',
  setup(__props) {

const {TOOL_toast, TOOL_loading, TOOL_TEXT} = injectTool();

// 分享页面中所有按钮点击事件都是此函数 打开app
const fnGoApp = () => {
    window.location.href = `https://sugo.onelink.me/gqNC/8d34d20a?source=invite`
}
//  html title
watchEffect(()=> document.title = TOOL_TEXT[1] || 'Loading...');


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(_ctx.MIXIN_TEXT[2]), 1 /* TEXT */)
    ]),
    _createElementVNode("div", {
      class: "rule_btn public_flex_center",
      onClick: fnGoApp
    }, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.MIXIN_TEXT[71]), 1 /* TEXT */)
    ]),
    _createVNode(Home)
  ]))
}
}

})